// extracted by mini-css-extract-plugin
export var heroVideo = "InlineHTML5Showreel-module--heroVideo--rNRYb";
export var video = "InlineHTML5Showreel-module--video--JXTDg";